import { Container } from "@mui/material";
import TemaDetalleView from "../../components/tema/TemaDetalleView";

/** Ficha pública de un tema (`/temas/:id`). Solo resuelve temas disponibles. */
export default function TemaDetalle() {
  return (
    <Container maxWidth="lg" sx={{ py: { xs: 5, md: 7 }, minHeight: "55vh" }}>
      <TemaDetalleView />
    </Container>
  );
}
